import { render, staticRenderFns } from "./CodigosPromocion.vue?vue&type=template&id=7fd584e5&"
import script from "./CodigosPromocion.vue?vue&type=script&lang=js&"
export * from "./CodigosPromocion.vue?vue&type=script&lang=js&"
import style0 from "./CodigosPromocion.vue?vue&type=style&index=0&id=7fd584e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports